import { render, staticRenderFns } from "./FeeIncome.vue?vue&type=template&id=7060da04&"
import script from "./FeeIncome.vue?vue&type=script&lang=js&"
export * from "./FeeIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports